module.exports = __webpack_public_path__ + "img/animals_on_the_wall.55a9f501.jpg";